const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "FISHING_VESSEL_POSTFIX_RETRIEVED":
            return action.fishingVesselPostfixes;

        default:
            return state;
    }
}
